module.exports = __webpack_public_path__ + "static/media/stephanie-selector.c31cf0d6.png";